var map = {
	"./de/translation.json": 62168,
	"./en/translation.json": 61996,
	"./es/translation.json": 64107,
	"./fr/translation.json": 65387
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 82507;
module.exports = webpackAsyncContext;